import React from 'react';
import { motion } from 'framer-motion';

interface AnimatedCardProps {
  children: React.ReactNode;
  id: string;
  className?: string;
}

const AnimatedCard: React.FC<AnimatedCardProps> = React.memo(({ children, id, className = "" }) => {
  return (
    <motion.div
      key={id}
      layout
      initial={{ opacity: 0, y: 20 }}
      animate={{ 
        opacity: 1, 
        y: 0,
        transition: {
          type: "tween",
          ease: "easeOut",
          duration: 0.25
        }
      }}
      exit={{ 
        opacity: 0, 
        y: -20,
        transition: {
          type: "tween",
          ease: "easeIn",
          duration: 0.2
        }
      }}
      transition={{
        layout: {
          type: "tween",
          ease: "easeInOut",
          duration: 0.3
        }
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}, (prevProps, nextProps) => {
  // id와 className이 같고 children이 같으면 리렌더링하지 않음
  return (
    prevProps.id === nextProps.id &&
    prevProps.className === nextProps.className &&
    prevProps.children === nextProps.children
  );
});

AnimatedCard.displayName = 'AnimatedCard';

export default AnimatedCard; 